/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationCreateEventCategoryPayload = {
    name: string;
    description?: string | null;
    color: string;
    duration: number;
    price: string;
    location: IntegrationCreateEventCategoryPayload.location;
    currency?: IntegrationCreateEventCategoryPayload.currency;
    publicBookingEnabled?: boolean;
    privateBookingEnabled?: boolean;
    outageFeeEnabled?: boolean;
    paymentEnabled?: boolean;
};
export namespace IntegrationCreateEventCategoryPayload {
    export enum location {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
    export enum currency {
        EUR = 'EUR',
        CHF = 'CHF',
    }
}

